/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetPaymentProductInformationRequest} from '@cash-web/protos/squareup/cash/umpire/api/client/v1/payment_product_information.pb'
import {GetPaymentProductInformationResponse} from '@cash-web/protos/squareup/cash/umpire/api/client/v1/payment_product_information.pb'


export const getPaymentProductInformation = (request: GetPaymentProductInformationRequest, options?: CashRequestOptions) => post<GetPaymentProductInformationRequest, GetPaymentProductInformationResponse>("/2.0/cash/get-payment-product-information", request, {...options, rejectOnError: true })